import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {UIGameMapTileView} from './UIGameMapTileView'
import {UIGameManager} from '../UIGameManager'
import {Point, TileHex} from '@colonist/game-mechanic-validators'

export abstract class UIGameBaseTileController {
    protected readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
    }

    protected drawTile(tile: TileHex): UIGameMapTileView {
        const tileCenter = tile.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2)

        const texture = UIGameSpriteHandler.getHexImage(tile.tileType)

        const hexW = this.uiGameManager.mapController.mapView.hexagonWidth
        const hexH = this.uiGameManager.mapController.mapView.hexagonHeight
        const tileView = this.drawTileView(tile, tileCenter, hexW, hexH, texture)
        tileView.drawProbability(tile.diceNumber)
        return tileView
    }

    private drawTileView(tile: TileHex, tileCenter: Point, hexW: number, hexH: number, texture: PIXI.Texture): UIGameMapTileView {
        const x = tileCenter.x - hexW / 2
        const y = tileCenter.y - hexH / 2
        const w = hexW
        const h = hexH
        const mapView = this.uiGameManager.mapController.mapView
        return new UIGameMapTileView(this.uiGameManager, tile.hexFace, x, y, w, h, texture, mapView)
    }
}
